export default __webpack_public_path__ + "static/media/banner.a058788a.png";